import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AutomobileModel } from './automobile-model';

@inheritSerialization(AbstractModel)
export class Automobile extends AbstractModel {
  @autoserialize
  year: string;

  @autoserializeAs(AutomobileModel)
  automobileModel: AutomobileModel;
}
